import { render, staticRenderFns } from "./ProviderType.vue?vue&type=template&id=63e53b5c&scoped=true"
import script from "./ProviderType.vue?vue&type=script&lang=js"
export * from "./ProviderType.vue?vue&type=script&lang=js"
import style0 from "./ProviderType.vue?vue&type=style&index=0&id=63e53b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e53b5c",
  null
  
)

export default component.exports